module.exports = __webpack_public_path__ + "static/media/login2-right.e47be907.jpg";